import { ProductViewConfigurator } from '~/types/configurator';

let label;
let imageUrl;
let description;

export default {
    controls: [
        {
            key: 'tubeMaterial',
            keyLabel: 'tube material',
            label: 'Paper Tube Material',
            displayAsImages: true,
            choices: [
                {
                    label: (label = 'White Kraft'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/color-white-tube.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'white-kraft',
                    description: (description =
                        'A gently-textured, paper-based material that’s light, strong, and 100% curbside recyclable. Kraft paper tubes can stand up to rough handling during shipping and keep their contents intact.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Brown Kraft'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/color-brown-tube.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'brown-kraft',
                    description: (description =
                        'All the properties and benefits of white kraft, presented in a pleasing shade of brown. Brown kraft paper tubes feature a white inner layer.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Paper tube material options:',
        },
        {
            key: 'labelMaterial',
            keyLabel: 'label material',
            label: 'Label Material',
            choices: [
                {
                    label: (label = 'Smooth White'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/label-color-smooth-white.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'smooth-white',
                    description: (description =
                        'Made from 30% post-consumer material, this label adds a bright, crisp look to artwork and closely matches our white kraft paper tube. (FSC Certified).'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Etched White Stone'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/label-color-etched-white-stone.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'etched-white-stone',
                    description: (description =
                        'Made from textured, bright white material containing 30% post-consumer waste, this label has two embossed patterns: a fine vein on the surface and a deeper-set pattern, creating a cobblestone-like appearance. (FSC Certified).'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Recycled Brown Kraft'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/label-color-recycled-brown-kraft.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'recycled-brown-kraft',
                    description: (description =
                        'Made from 100% post-consumer ecycled paper material, this label blends perfectly with our brown kraft paper tube, creating the illusion of printing directly onto the packaging.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = '50/50 Recycled Hemp'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/label-color-50-50-recycled-hemp.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'recycled-hemp',
                    description: (description =
                        'Made from 50% post-consumer material and 50% hemp, this label is supremely sustainable and touchably soft.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Label material options:',
        },
    ],
} as ProductViewConfigurator;
